/* import __COLOCATED_TEMPLATE__ from './office-hours-variant.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class OfficeHoursBotInboxModifier extends Component {
  @service reportingMetrics;
  @service intl;

  get metricIdToUse() {
    return this.args.currentMetric.id === this.currentMetricDefaultId
      ? this.currentMetricVariantId
      : this.currentMetricDefaultId;
  }

  get currentMetricVariantId() {
    return this.reportingMetrics
      .getMetricsByFamilyId(this.args.currentMetric.metricFamilyId)
      .find((metric) => !metric.metricFamilyDefault).id;
  }

  get currentMetricDefaultId() {
    return this.reportingMetrics
      .getMetricsByFamilyId(this.args.currentMetric.metricFamilyId)
      .find((metric) => metric.metricFamilyDefault).id;
  }

  get officeHoursVariantIsSelected() {
    return this.args.currentMetric.id.includes('in_office_hours');
  }

  set officeHoursVariantIsSelected(_value) {
    this.args.selectMetric(this.metricIdToUse);
  }

  get tooltip() {
    let href = 'https://app.intercom.com/a/apps/_/settings/office-hours';
    return this.intl.t('reporting.custom-reports.chart.office-hours-variant.tooltip', {
      href,
      htmlSafe: true,
    });
  }
}
